import { StreamActions } from '@hotwired/turbo'
import DrawerController from '../../stimulus/controllers/drawer'

StreamActions.close_drawer = function () {
  const lastDrawer = Array.from(document.querySelectorAll('dialog[data-controller~=drawer]')).at(-1)

  if (!lastDrawer) return console.warn('No drawer to close')

  const drawerController = window.Stimulus.getControllerForElementAndIdentifier(
    lastDrawer,
    'drawer',
  ) as DrawerController

  if (!drawerController) return console.warn('No drawer controller found')

  drawerController.close()
}
